import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchReports } from "../../../api/endpoint";
import Loader from "../../../components/loader";
import { BsInfoCircle } from "react-icons/bs";
import axios from "axios";
import Table from "../../../components/table";
import { useNavigate } from "react-router-dom";

const Game = () => {
  const { auth } = useSelector((state) => state.login);

  const [tableData, setTableData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  const headings = [
    { name: "S No.", fieldName: "sNo", isSortable: false },
    { name: "Reporter", fieldName: "reporter", isSortable: false },
    { name: "Reason", fieldName: "reason", isSortable: false },
    { name: "Game", fieldName: "game", isSortable: false },
    { name: "Host", fieldName: "host", isSortable: false },
    { name: "Status", fieldName: "status", isSortable: false },
    { name: "Actions", fieldName: "actions", isSortable: false },
  ];

  useEffect(() => {
    if (auth) {
      fetchGameReports();
    }
  }, [auth, statusFilter]);

  const handleOpenDetails = (reportId) => {
    navigate("/game-report-details", {
      state: { reportId },
    });
  };

  const getActionButtons = (reportId) => (
    <div className="d-flex align-items-center gap-2">
      <button
        className="btn p-0 mb-1"
        onClick={() => handleOpenDetails(reportId)}
        style={{ cursor: "pointer" }}
        title="View Details"
      >
        <BsInfoCircle size={20} />
      </button>
    </div>
  );

  const fetchGameReports = async () => {
    try {
      setLoading(true);
      const params = {
        type: "GAME",
        ...(statusFilter !== "ALL" && { status: statusFilter }),
      };

      const response = await axios.get(fetchReports, {
        headers: { Authorization: `Bearer ${auth}` },
        params,
      });

      const data = response?.data?.content?.map((r, i) => ({
        sNo: i + 1,
        reporter: r?.reporterName,
        reason: r?.reason,
        game: r?.additionalData?.gameName,
        host: r?.additionalData?.hostName,
        status: r?.status,
        actions: getActionButtons(r?.reportId),
      }));

      setTableData(data);
      setCurrentPage(response?.data?.currentPage);
      setPageSize(response?.data?.pageSize);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Status Filter */}
      <div className="d-flex gap-2 align-items-center justify-content-end">
        <label>Status:</label>
        <select
          className="form-select form-select-sm w-auto"
          onChange={(e) => setStatusFilter(e.target.value)}
          value={statusFilter}
        >
          <option value="ALL">All</option>
          <option value="REVIEWING">Reviewing</option>
          <option value="ACTION_TAKEN">Action taken</option>
          <option value="REJECTED">Rejected</option>
          <option value="CLOSED">Closed</option>
        </select>
      </div>

      {/* Table */}
      <Table
        headings={headings}
        data={tableData}
        currentPage={currentPage}
        totalPages={totalPages}
        enablePagination={tableData?.length > pageSize}
        card={true}
      />

      {loading && <Loader />}
    </div>
  );
};

export default Game;
